import { configureStore } from '@reduxjs/toolkit'
import usersReducer from '../features/users/usersSlice'
import appReducer from '../features/app/appSlice'


export default configureStore({
    reducer: {
        users: usersReducer,
        app: appReducer,
    },
})